<template lang="pug">
.v-confirm-location-modal.confirm-location-modal(v-if="data" )
	.confirm-location-modal__head
		span.confirm-location-modal__title(v-if="data.title" ) {{ data.title }}&nbsp;
		span.confirm-location-modal__name(v-if="data.name" ) {{ data.name }}
		span ?
	.confirm-location-modal__buttons
		button.confirm-location-modal__button(v-for="(button, index) in data.buttons"
				:key="index"
				:class="button.className"
				@click="handleEvent(button.event)")
				| {{ button?.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
export default {
	mixins: [
		sourceMixin,
	],

	data() {
		return {
			data: null
		};
	},

	computed: {
		geolocationData() {
			return this.$store.state.location;
		},

		computedField() {
			let field;
			let options = [];
			this.geolocationData.items.forEach(item => {
				options.push({
					value: item.cityId,
					text: item.text
				});
			});
			let currentLocation = this.geolocationData.items.find(item => item.cityId === this.geolocationData.cityId);
			if (options.length > 0) {
				field = {
					type: 'modal-select',
					value: currentLocation,
					title: this.geolocationData.title,
					buttons: this.geolocationData.buttons,
					bxajaxid: this.geolocationData.bxajaxid,
					options
				};
			}
			return field;
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		handleEvent(event) {
			switch (event) {
				case 'close': {
					controller.closeModal();
					break;
				}
				case 'edit': {
					controller.closeModal();
					controller.openModal({
						className: 'modal--select modal-regions',
						component: {
							name: 'v-modal-select',
							props: {
								dataSource: this.computedField,
								modelValue: this.geolocationData.cityId,
							},
							listeners: {
								'change-select': async (data) => {
									this.geolocationData.cityId = data;
								},

								'update:model-value': async (data) => {
									this.$store.dispatch('location/update', {
										cityId: data,
										bxajaxid: this.computedField.bxajaxid ? this.computedField.bxajaxid : null,
									});
									// this.$emit('update:model-value', data);
								}
							}
						}
					});
					break;
				}
			}
		}
	}
};
</script>